module.exports = __webpack_public_path__ + "img/login-background.d50231ae.png";